import { createAction } from '@reduxjs/toolkit';
import type { ProfileSort } from '@shared/schemas';

import type { FilterGroup } from '@/types/filters';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. Kept out of
 * the slice's reducers: they trigger the paginated fetch (a side effect), not the
 * state transitions (the saga owns the resulting `load*` / cursor transitions).
 */

/** Refetch the current page (after out-of-band mutations like add-tags). */
export const trackedLpsRequested = createAction('trackedLps/trackedLpsRequested');

/** The debounced, pruned server filters changed (resets to the first page). */
export const filtersChanged = createAction<FilterGroup | null>('trackedLps/filtersChanged');

/**
 * A sort arrow was clicked (#710): the server orders the whole list, and the
 * table goes back to its first page. Null = back to the default name order.
 */
export const sortChanged = createAction<ProfileSort | null>('trackedLps/sortChanged');
/** Navigate to a 0-indexed page. */
export const pageChanged = createAction<number>('trackedLps/pageChanged');

/** Change the page size (resets to the first page). */
export const pageSizeChanged = createAction<number>('trackedLps/pageSizeChanged');

/**
 * A profile was un-favorited from the shared FavoriteButton column. The saga
 * removes the row optimistically, then refetches to reconcile the total (the
 * button calls back once its write has landed).
 */
export const favoriteRemoved = createAction<string>('trackedLps/favoriteRemoved');
